import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ConsentState } from "./consentInterfaces";

const initialState: ConsentState = {
  consented: undefined,
  isUpdating: false,
  updated: false,
  error: null,
};

const marketingConsentSlice = createSlice({
  name: "marketingConsent",
  initialState,
  reducers: {
    marketingConsentUpdateFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload?.toString();
      state.isUpdating = false;
    },

    setMarketingConsented: (state, _action: PayloadAction<string>) => {
      state.isUpdating = true;
    },

    updateMarketingConsent: (state, _action: PayloadAction<string>) => {
      state.isUpdating = true;
    },

    updateMarketingConsentSucceeded: (
      state,
      action: PayloadAction<boolean | undefined>,
    ) => {
      state.consented = action.payload;
      state.isUpdating = false;
      state.updated = true;
      state.error = null;
    },
  },
});

export const {
  setMarketingConsented,
  marketingConsentUpdateFailed,
  updateMarketingConsent,
  updateMarketingConsentSucceeded,
} = marketingConsentSlice.actions;

export const marketingConsent = marketingConsentSlice.reducer;
